import { render, staticRenderFns } from "./VideoTimeline.vue?vue&type=template&id=159ffd66&scoped=true&"
import script from "./VideoTimeline.vue?vue&type=script&lang=ts&setup=true&"
export * from "./VideoTimeline.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./VideoTimeline.vue?vue&type=style&index=0&id=159ffd66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ffd66",
  null
  
)

export default component.exports